export const products_data = [
  {
    id: 1,
    name: "Galaxy S21",
    keyFeatureList: ["6.2-inch display", "128GB storage", "8GB RAM", "4000mAh battery"],
    price: 799.99,
    smallDescription: "A powerful smartphone with a sleek design and high-end performance.",
    category: "mobile",
    image: "/images/galaxy_s21_mobile.jpg"
  },
  {
    id: 2,
    name: "iPhone 13",
    keyFeatureList: ["6.1-inch display", "128GB storage", "4GB RAM", "3240mAh battery"],
    price: 829.99,
    smallDescription: "The latest iPhone with improved cameras and longer battery life.",
    category: "mobile",
    image: "/images/iphone_13_mobile.jpg"
  },
  {
    id: 3,
    name: "Pixel 6",
    keyFeatureList: ["6.4-inch display", "128GB storage", "8GB RAM", "4614mAh battery"],
    price: 699.99,
    smallDescription: "Google's flagship phone with an excellent camera and pure Android experience.",
    category: "mobile",
    image: "/images/pixel_6_mobile.jpg"
  },
  {
    id: 4,
    name: "OnePlus 9",
    keyFeatureList: ["6.55-inch display", "128GB storage", "8GB RAM", "4500mAh battery"],
    price: 729.99,
    smallDescription: "A high-performance phone with fast charging and smooth display.",
    category: "mobile",
    image: "/images/oneplus_9_mobile.jpg"
  },
  {
    id: 5,
    name: "Sony Xperia 5 II",
    keyFeatureList: ["6.1-inch display", "128GB storage", "8GB RAM", "4000mAh battery"],
    price: 949.99,
    smallDescription: "A compact phone with powerful hardware and a great camera.",
    category: "mobile",
    image: "/images/sony_xperia_5_ii_mobile.jpg"
  },
  {
    id: 6,
    name: "MacBook Pro",
    keyFeatureList: ["13.3-inch display", "256GB SSD", "8GB RAM", "M1 chip"],
    price: 1299.99,
    smallDescription: "A high-performance laptop with the new M1 chip for faster processing.",
    category: "laptop",
    image: "/images/macbook_pro_laptop.jpg"
  },
  {
    id: 7,
    name: "Dell XPS 13",
    keyFeatureList: ["13.4-inch display", "256GB SSD", "8GB RAM", "Intel i7"],
    price: 999.99,
    smallDescription: "A compact and powerful laptop with an edge-to-edge display.",
    category: "laptop",
    image: "/images/dell_xps_13_laptop.jpg"
  },
  {
    id: 8,
    name: "HP Spectre x360",
    keyFeatureList: ["13.3-inch display", "512GB SSD", "16GB RAM", "Intel i7"],
    price: 1199.99,
    smallDescription: "A versatile 2-in-1 laptop with excellent performance and design.",
    category: "laptop",
    image: "/images/hp_spectre_x360_laptop.jpg"
  },
  {
    id: 9,
    name: "Lenovo ThinkPad X1 Carbon",
    keyFeatureList: ["14-inch display", "512GB SSD", "16GB RAM", "Intel i7"],
    price: 1399.99,
    smallDescription: "A durable and high-performance business laptop.",
    category: "laptop",
    image: "/images/lenovo_thinkpad_x1_carbon_laptop.jpg"
  },
  {
    id: 10,
    name: "Asus ROG Zephyrus G14",
    keyFeatureList: ["14-inch display", "1TB SSD", "16GB RAM", "AMD Ryzen 9"],
    price: 1499.99,
    smallDescription: "A powerful gaming laptop with a compact design.",
    category: "laptop",
    image: "/images/asus_rog_zephyrus_g14_laptop.jpg"
  },
  {
    id: 11,
    name: "iPad Pro",
    keyFeatureList: ["11-inch display", "128GB storage", "8GB RAM", "Apple M1"],
    price: 799.99,
    smallDescription: "A versatile tablet with powerful performance and a stunning display.",
    category: "tablet",
    image: "/images/ipad_pro_tablet.jpg"
  },
  {
    id: 12,
    name: "Samsung Galaxy Tab S7",
    keyFeatureList: ["11-inch display", "128GB storage", "6GB RAM", "8000mAh battery"],
    price: 649.99,
    smallDescription: "A high-end Android tablet with a large screen and long battery life.",
    category: "tablet",
    image: "/images/samsung_galaxy_tab_s7_tablet.jpg"
  },
  {
    id: 13,
    name: "Microsoft Surface Pro 7",
    keyFeatureList: ["12.3-inch display", "256GB SSD", "8GB RAM", "Intel i5"],
    price: 899.99,
    smallDescription: "A versatile 2-in-1 tablet with laptop-level performance.",
    category: "tablet",
    image: "/images/microsoft_surface_pro_7_tablet.jpg"
  },
  {
    id: 14,
    name: "Lenovo Tab P11 Pro",
    keyFeatureList: ["11.5-inch display", "128GB storage", "6GB RAM", "8600mAh battery"],
    price: 499.99,
    smallDescription: "A sleek and powerful Android tablet with a great display.",
    category: "tablet",
    image: "/images/lenovo_tab_p11_pro_tablet.jpg"
  },
  {
    id: 15,
    name: "Amazon Fire HD 10",
    keyFeatureList: ["10.1-inch display", "64GB storage", "4GB RAM", "6300mAh battery"],
    price: 149.99,
    smallDescription: "An affordable tablet with a large screen and long battery life.",
    category: "tablet",
    image: "/images/amazon_fire_hd_10_tablet.jpg"
  },
  {
    id: 16,
    name: "Huawei MatePad Pro",
    keyFeatureList: ["10.8-inch display", "128GB storage", "6GB RAM", "7250mAh battery"],
    price: 599.99,
    smallDescription: "A high-performance Android tablet with a sleek design.",
    category: "tablet",
    image: "/images/huawei_matepad_pro_tablet.jpg"
  },
  {
    id: 17,
    name: "Google Pixel Slate",
    keyFeatureList: ["12.3-inch display", "128GB SSD", "8GB RAM", "Intel i5"],
    price: 999.99,
    smallDescription: "A versatile 2-in-1 device with Chrome OS.",
    category: "tablet",
    image: "/images/google_pixel_slate_tablet.jpg"
  },
  {
    id: 18,
    name: "Asus ZenBook 14",
    keyFeatureList: ["14-inch display", "512GB SSD", "16GB RAM", "Intel i7"],
    price: 1099.99,
    smallDescription: "A lightweight and powerful laptop with a sleek design.",
    category: "laptop",
    image: "/images/asus_zenbook_14_laptop.jpg"
  },
  {
    id: 19,
    name: "Acer Swift 3",
    keyFeatureList: ["14-inch display", "256GB SSD", "8GB RAM", "AMD Ryzen 7"],
    price: 699.99,
    smallDescription: "A budget-friendly laptop with solid performance.",
    category: "laptop",
    image: "/images/acer_swift_3_laptop.jpg"
  },
  {
    id: 20,
    name: "Razer Blade 15",
    keyFeatureList: ["15.6-inch display", "512GB SSD", "16GB RAM", "Intel i7"],
    price: 1799.99,
    smallDescription: "A premium gaming laptop with top-notch performance.",
    category: "laptop",
    image: "/images/razer_blade_15_laptop.jpg"
  },
  {
    id: 21,
    name: "Xiaomi Mi 11",
    keyFeatureList: ["6.81-inch AMOLED display", "128GB storage", "8GB RAM", "4600mAh battery"],
    price: 749.99,
    smallDescription: "A powerful phone with a large display and top-notch performance.",
    category: "mobile",
    image: "/images/xiaomi_mi_11_mobile.jpg"
  },
  {
    id: 22,
    name: "Samsung Galaxy S20 FE",
    keyFeatureList: ["6.5-inch AMOLED display", "128GB storage", "6GB RAM", "4500mAh battery"],
    price: 699.99,
    smallDescription: "A fan edition smartphone with great value for money.",
    category: "mobile",
    image: "/images/samsung_galaxy_s20_fe_mobile.jpg"
  },
  {
    id: 23,
    name: "Motorola Edge Plus",
    keyFeatureList: ["6.7-inch OLED display", "256GB storage", "12GB RAM", "5000mAh battery"],
    price: 999.99,
    smallDescription: "A premium phone with 5G connectivity and flagship features.",
    category: "mobile",
    image: "/images/motorola_edge_plus_mobile.jpg"
  },
  {
    id: 24,
    name: "iPad Air",
    keyFeatureList: ["10.9-inch Liquid Retina display", "64GB storage", "4GB RAM", "A14 Bionic chip"],
    price: 599.99,
    smallDescription: "A mid-range tablet offering great value and performance.",
    category: "tablet",
    image: "/images/ipad_air_tablet.jpg"
  },
  {
    id: 25,
    name: "Microsoft Surface Go 3",
    keyFeatureList: ["10.5-inch display", "64GB storage", "4GB RAM", "Intel Pentium Gold"],
    price: 399.99,
    smallDescription: "A budget 2-in-1 tablet for everyday use.",
    category: "tablet",
    image: "/images/surface_go_3_tablet.jpg"
  },
  {
    id: 26,
    name: "Huawei MateBook X Pro",
    keyFeatureList: ["13.9-inch display", "512GB SSD", "16GB RAM", "Intel i7"],
    price: 1599.99,
    smallDescription: "A premium ultrabook with a sleek design and powerful performance.",
    category: "laptop",
    image: "/images/huawei_matebook_x_pro_laptop.jpg"
  },
  {
    id: 27,
    name: "Lenovo Legion 5 Pro",
    keyFeatureList: ["16-inch display", "1TB SSD", "32GB RAM", "AMD Ryzen 7"],
    price: 1799.99,
    smallDescription: "A gaming laptop with excellent performance and a large screen.",
    category: "laptop",
    image: "/images/lenovo_legion_5_pro_laptop.jpg"
  },
  {
    id: 28,
    name: "Dell Inspiron 15",
    keyFeatureList: ["15.6-inch display", "512GB SSD", "8GB RAM", "Intel i5"],
    price: 649.99,
    smallDescription: "A reliable budget laptop with decent performance.",
    category: "laptop",
    image: "/images/dell_inspiron_15_laptop.jpg"
  },
  {
    id: 29,
    name: "Samsung Galaxy Book Pro 360",
    keyFeatureList: ["13.3-inch AMOLED display", "256GB SSD", "8GB RAM", "Intel i7"],
    price: 1399.99,
    smallDescription: "A premium convertible laptop with excellent display and performance.",
    category: "laptop",
    image: "/images/samsung_galaxy_book_pro_360_laptop.jpg"
  },
  {
    id: 30,
    name: "Acer Predator Helios 300",
    keyFeatureList: ["15.6-inch display", "1TB SSD", "16GB RAM", "Intel i7"],
    price: 1599.99,
    smallDescription: "A gaming powerhouse with exceptional cooling and performance.",
    category: "laptop",
    image: "/images/acer_predator_helios_300_laptop.jpg"
  }
];

export const products_categories = [
  { label: 'Mobile', value: 'mobile' },
  { label: 'Tablet', value: 'tablet' },
  { label: 'Laptop', value: 'laptop' }
];
